/**
 * Forme de regroupement d'une cuisine (US-55).
 *
 * Même patron qu'`ingredient.name_normalized` : c'est la colonne sur laquelle
 * on filtre et on regroupe, jamais celle qu'on affiche. « Italienne »,
 * « italienne » et « ITALIENNE » sont la même cuisine ; « Italien » l'est
 * aussi, et c'est la seule normalisation de forme qu'on se permette — le
 * masculin et le féminin d'un adjectif de nationalité désignent la même chose,
 * et les distinguer produirait deux entrées dans la liste d'autocomplétion pour
 * la même cuisine.
 *
 * **On ne va pas plus loin.** Pas de racinisation, pas de dictionnaire, pas de
 * pluriel : « pâtes » n'est pas une cuisine et n'a pas à être deviné. Le §1
 * s'applique — on ne devine jamais.
 *
 * **Remontée dans `shared/` en US-73**, pour la même raison que
 * `foldLigatures` : le prédicat de collection compare une cuisine proposée à
 * celle d'une collection, côté navigateur, et une seconde normalisation
 * « presque pareille » ferait diverger la ligne « Rejoindra » de ce que la
 * recherche ramène. Le module du serveur reste, et réexporte.
 */

const DIACRITIQUES = new RegExp('[\\u0300-\\u036f]', 'g');

export function normalizeCuisine(valeur: string | null | undefined): string | null {
  if (valeur === null || valeur === undefined) return null;
  const plie = valeur
    .normalize('NFD')
    .replace(DIACRITIQUES, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
  if (plie === '') return null;
  // « italien » et « italienne » : même cuisine. La finale « -ienne » se ramène
  // à « -ien », et rien d'autre n'est touché.
  return plie.replace(/ienne$/, 'ien');
}
